import React, { useCallback, useEffect, useState } from "react";

import EcoIcon from "../../../components/eco-icon/EcoIcon";
import type { StorePublic } from "../storeApi";
import StoreDataForm from "./StoreDataForm";

type StoreFormPanelProps = {
  onClose: () => void;
  onSaved: (store: StorePublic) => void;
};

/**
 * Painel lateral de cadastro de loja nova (no celular, ocupa a tela). Editar
 * uma loja que já existe é na ficha da loja (`/lojas/:id`), com o horário, a
 * posição, a equipe e o quiosque juntos (plan-notificacoes-whatsapp, 22/10/2026).
 */
const StoreFormPanel: React.FC<StoreFormPanelProps> = ({ onClose, onSaved }) => {
  const [saving, setSaving] = useState(false);
  const [valid, setValid] = useState(false);
  const handleValid = useCallback((v: boolean) => setValid(v), []);

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape" && !saving) onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = prevOverflow;
    };
  }, [onClose, saving]);

  return (
    <div className="storePanel__overlay" role="presentation" onClick={() => !saving && onClose()}>
      <aside
        className="storePanel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="storePanel-title"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="storePanel__header">
          <div className="storePanel__heading">
            <span className="storePanel__eyebrow">Lojas</span>
            <h2 id="storePanel-title" className="storePanel__title">
              Nova loja
            </h2>
            <p className="storePanel__hint">
              O nome fantasia precisa ser único. Horário, posição, equipe e quiosque ficam na ficha da loja, que abre ao cadastrar.
            </p>
          </div>
          <button type="button" className="ecoBtn ecoBtn--icon" onClick={onClose} aria-label="Fechar" disabled={saving}>
            <EcoIcon name="x" />
          </button>
        </header>

        <StoreDataForm
          store={null}
          formId="storePanel-form"
          autoFocus
          onSavingChange={setSaving}
          onValidChange={handleValid}
          onSaved={(store) => onSaved(store)}
        />

        <footer className="storePanel__footer">
          <button type="button" className="ecoBtn" onClick={onClose} disabled={saving}>
            Cancelar
          </button>
          <button type="submit" form="storePanel-form" className="ecoBtn ecoBtn--primary" disabled={!valid || saving}>
            {saving ? "Salvando..." : "Cadastrar loja"}
          </button>
        </footer>
      </aside>
    </div>
  );
};

export default StoreFormPanel;
